import React, {useState, useEffect, useContext} from 'react';
import {
    Container,
    Grid,    
} from '@mui/material';
import { OneWamboPerformanceStatus, OneCpPerformanceStatus } from '../gas/shared/service';
import  LineChart  from '../shared/charts/LineChart';
import {CurrentUserContext} from "../../components/CurrentUserContext";

const PerformanceDashboard = () => {
    const [dashboardAccess, setDashboardAccess] = useState(false);
    const [eposPerDay, setEpoPerDay] = useState([]);
    const [reqsPerDay, setReqPerDay] = useState([]);
    const [createInvPerDay, setCreateInvPerDay] = useState([]);
    const [deferInvPerDay, setDeferInvPerDay] = useState([]);
    const [paidInvPerDay, setPaidInvPerDay] = useState([]);
    const [deferVoucherPerDay, setDeferVoucherPerDay] = useState([]);
    const [createVoucherPerDay, setCreateVoucherPerDay] = useState([]);
    const [createVoucherFailurePerDay, setCreateVoucherFailurePerDay] = useState([]);
    const [deferVoucherFailurePerDay, setDeferVoucherFailurePerDay] = useState([]);
    const user = useContext(CurrentUserContext);

     useEffect(() =>{      
       const roleList = user.rights;
        for(let roleSet of roleList){
            if(roleSet.includes('ROLE_STATUS_USER')){
            setDashboardAccess(true);
            OneWamboPerformanceStatus.getAll().then((response)=> {            
              setEpoPerDay(response.data.eposPerDayList);
              setReqPerDay(response.data.reqsPerDayList);             
            })     
            OneCpPerformanceStatus.getAll().then((response) => {
              setCreateInvPerDay(response.data.createInvoicesPerDay);
              setDeferInvPerDay(response.data.deferInvoicesPerDay);
              setPaidInvPerDay(response.data.paidVouchersPerDay);
              setDeferVoucherPerDay(response.data.deferVouchersPerDay);
              setCreateVoucherPerDay(response.data.createVouchersPerDay);
              setCreateVoucherFailurePerDay(response.data.createVoucherFailuresPerDay);
              setDeferVoucherFailurePerDay(response.data.deferVoucherFailuresPerDay);
                })    
              }  
            }
    }, [])

    

    return (
        <Container>
        {dashboardAccess && 
     <Grid >
        <Grid container spacing={4}  alignItems="center"
           justifyContent="center" margin={2} fontSize={15}>
             <h1 style={{color: "rgb(47, 101, 203)"}}>Integrations Performance Dashboard</h1> 
       </Grid>           
         <Grid container spacing={4} style={containerStyle}>
               <h2>Wambo to OneNet integration performance monitoring metrics</h2>
        
               <Grid container spacing={4}>
                <Grid item xs={4} style={chartFormat}>
                <LineChart  data={eposPerDay}
                   label={["Epo per day"]}
                   fields={["capturedDate","recordCount"]}   
                   chart_options={{
                     title: "Epos per day for the past 30 days",
                     axisReverse: true,
                   }} />
                  </Grid>
                  <Grid item xs={4} style={chartFormat}>
                  <LineChart  data={reqsPerDay}
                   label={["Requisition per day"]}
                   fields={["capturedDate","recordCount"]}   
                   chart_options={{
                     title: "Requisitions per day for the past 30 days",
                     axisReverse: true,
                    }} />
                  </Grid>
                 </Grid>
       </Grid>
               
       <Grid container spacing={4} style={containerStyle}>          
                <h2>OneNet to Costpoint integration performance monitoring metrics</h2>
   
         <Grid container spacing={4}>
          <Grid item xs={4} style={chartFormat}>
          <LineChart  data={createInvPerDay}
             label={["Create Invoice Per Day"]}
             fields={["capturedDate","recordCount"]}   
             chart_options={{
               title: "Create Invoices per day for the past 30 days",
               axisReverse: true,
    }} />
          </Grid>
          <Grid item xs={4} style={chartFormat}>
          <LineChart  data={deferInvPerDay}
           label={["Defer Invoices per day"]}
           fields={["capturedDate","recordCount"]}   
           chart_options={{
             title: "Defer Invoices per day for the past 30 days",
             axisReverse: true,
            }} />
          </Grid>
          <Grid item xs={4} style={chartFormat}>
          <LineChart  data={paidInvPerDay}
             label={["Paid Invoices per day"]}
             fields={["capturedDate","recordCount"]}   
             chart_options={{
               title: "Paid Invoices per day for the past 30 days",
               axisReverse: true,
                }} />
          </Grid>
         </Grid>
      <Grid container spacing={4}>
         <Grid item xs={4} style={chartFormat}>
          <LineChart  data={createVoucherPerDay}
           label={["Create Voucher per day"]}
           fields={["capturedDate","recordCount"]}   
           chart_options={{
             title: "Create Voucher  per day for the past 30 days",
             axisReverse: true,
            }} />
          </Grid>
          <Grid item xs={4} style={chartFormat}>
          <LineChart  data={deferVoucherPerDay}
           label={["Defer Voucher per day"]}
           fields={["capturedDate","recordCount"]}   
           chart_options={{
             title: "Defer Voucher  per day for the past 30 days",
             axisReverse: true,
            }} />
          </Grid>
      </Grid>
      <Grid container spacing={4}>
         <Grid item xs={4} style={chartFormat}>
          <LineChart  data={createVoucherFailurePerDay}
             label={["Failed Create Voucher per day"]}
             fields={["capturedDate","recordCount"]}   
             chart_options={{
               title: "Failed Create Voucher per day for the past 30 days",
               axisReverse: true,
                  }} />
          </Grid>
          <Grid item xs={4} style={chartFormat}>
          <LineChart  data={deferVoucherFailurePerDay}
             label={["Failed Defer Voucher per day"]}
             fields={["capturedDate","recordCount"]}   
             chart_options={{
               title: "Failed Defer Voucher per day for the past 30 days",
               axisReverse: true,
                  }} />
          </Grid>       
      </Grid>
   </Grid>
 </Grid>
       }

        </Container>
    );
};

const chartFormat = {
  position: "relative",
  background: "White",
  margin: "2rem 0rem 0rem 0rem",
  padding: "1rem"
};

const containerStyle = {
  margin: "0 0 2rem 0"
}





export default PerformanceDashboard;
